import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../App";
import { action, API, controller } from "../../../api/api";

const SalesCounts = ({ open }) => {
  const { authUser } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState();

  useEffect(() => {
    if (authUser && open) {
      setLoading(true);
      API(controller.Sell + action.CurrentMonthAndTodaySaleByUser).get(
        (res) => {
          res && res.status === 200 && setAccounts({ ...res.result });
          setLoading(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser, open]);

  return (
    <>
      {!loading && accounts && (
        <>
          <div className="grid p-[20px] border-b">
            <div className="flex flex-wrap justify-between items-center">
              <span className="font-medium text-[18px] text-gray-500">
                Today
              </span>
              <div className="grid gap-[2px]">
                <span className="text-primary text-[12px] font-medium text-right">
                  {accounts.totalItemsSoldToday.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}{" "}
                  sale
                </span>
                <span className="text-[20px] font-bold text-gray-500">
                  ${" "}
                  {accounts.todayTotalSales.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>
            </div>
          </div>
          <div className="grid p-[20px] border-b">
            <div className="flex flex-wrap justify-between items-center">
              <span className="font-medium text-[18px] text-gray-500">
                This month
              </span>
              <div className="grid gap-[2px]">
                <span className="text-primary text-[12px] font-bold text-right">
                  {accounts.totalItemsSoldThisMonth.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}{" "}
                  sale
                </span>
                <span className="text-[20px] font-bold text-gray-500">
                  ${" "}
                  {accounts.thisMonthTotalSales.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SalesCounts;
